function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(.32)",
  fill: "#3C8EFF",
  "data-override": "fill",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 4.671,
  cy: 10.12,
  r: 1.557
}), React.createElement("circle", {
  cx: 10.12,
  cy: 10.12,
  r: 1.557
}), React.createElement("circle", {
  cx: 15.569,
  cy: 10.12,
  r: 1.557
}));

const SvgEllipsis = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 21,
  height: 21,
  viewBox: "0 0 21 21",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEllipsis, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;